/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_OtherInputs */

const vi_vehicle_type_other = /** @type {(inputs: Vehicle_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khác`)
};

/**

* @param {Vehicle_Type_OtherInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_other = /** @type {((inputs?: Vehicle_Type_OtherInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_OtherInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_type_other(inputs)
});